import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { AssessmentListService } from 'src/app/core/service/grid-data/grid-data-assessment.service';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import moment from 'moment';
import { ContactHistoryService } from 'src/app/core/service/contact-history.service';
import { Subscription } from 'rxjs';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { sortBy, cloneDeep } from 'lodash';
import { SelectEvent, TabStripComponent } from '@progress/kendo-angular-layout';
import { AssessmentService } from 'src/app/core/service/assessment.service';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { TranslateService } from '@ngx-translate/core';
import { DocumentService } from 'src/app/core/service/document.service';
import { saveAs } from '@progress/kendo-file-saver';
import { SettingService } from 'src/app/core/service/setting.service';
import { Code, Dictionary } from 'src/app/core/model/dictionary';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { IntlService } from '@progress/kendo-angular-intl';
import { FulfillmentMeta } from 'src/app/assessment/model/assessment';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { GridViewManager } from 'src/app/core/model/grid-view-manager';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { MemberService } from 'src/app/core/service/member.service';
import { ExtensionService } from 'src/app/core/service/extension.service';
import { MessageSubject, MessengerService } from 'src/app/core/service/messenger.service';
import { ResizedEvent } from '../../resize-event/resized-event';
import { WindowComponent } from '@progress/kendo-angular-dialog';
import { Base64Util } from 'src/app/core/utility/base64-util';

@Component({
  standalone: false,
  selector: 'app-member-assessment-add',
  templateUrl: './member-assessment-add.component.html',
  styleUrls: ['./member-assessment-add.component.scss']
})
export class MemberAssessmentAddComponent implements OnInit, OnDestroy, AfterViewChecked
{
  @ViewChild('survey') public survey: ElementRef;
  @ViewChild('tabstrip') public tabstrip: TabStripComponent;
  @ViewChild('singleSelect', { static: false }) public singleSelect: MultiSelectComponent;
  @ViewChild('formlyDiv') public formlyDiv: ElementRef;
  @ViewChild('window') public window: WindowComponent;
  @ViewChild('splitter', { read: ElementRef }) public splitter: ElementRef;

  @Input() public memberId: number = null;
  @Input() public taskId: number = null;
  @Input() public caseId: number = null;
  @Input() public assessmentId: number = null;

  @Output() public cancelling = new EventEmitter();
  @Output() public save = new EventEmitter();

  public assessmentForm: any;
  public dialogAddAssessmentOpened = false;
  public assessor: string;
  public maxDate: Date = moment().toDate();
  public contactMethods: Dictionary[] = [];
  public contactEntities: Dictionary[] = [];
  public patientMoods: Array<{ text: string; value: string; icon: string }>;
  public flagCategories: Code[];
  public flagPriorities: Code[];
  public assessments: any;
  public assessmentsFiltered = [];
  public flags: Code[];
  public creating = false;
  public windowState = 'maximized';
  public patViewExtensions: GridViewManager;
  public viewExtensionsShowDisplayName = false;
  public viewExtensionsShowAlternateValue = false;
  public defaultMaxExtensionHeight = 600;
  public currentMaxExtensionHeight = this.defaultMaxExtensionHeight;
  public maxWindowHeight = undefined;

  /**
   * Filtered list of flags for drop-down.
   */
  public flagsFiltered: Code[] = [];
  public allFlagsFiltered: Code[] = [];
  public allFlags: Code[];

  public currentDictionaryUsed = null;
  public previousDictionaryUsed = null;

  /**
   * Maximum number of items for flag virtualization. This is to accelerate the DOM performance.
   */
  public virtualFlag: any = {
    itemHeight: 30
  };

  public model = {};
  public fields: FormlyFieldConfig[] = [];
  public loadedFields: any = [];
  public formFulfillment = new UntypedFormGroup({});
  public showMoodTab = false;
  public showFlag = false;
  public showMood = false;
  public requiredMood = false;
  public selectedTab = 0;
  public dialogVisible: boolean = false;

  // Image restrictions
  public fileRestrictions: FileRestrictions =
    {
      allowedExtensions: ['.pdf', '.doc', '.docx'],
      maxFileSize: 2000
    };

  public invalidFileExtensionText: string;
  public selectedFile: any = null;
  public patientLabel = {};
  public recordContactFieldsSetting: string;

  /**
   * Current search term entered from a comboxbox
   */
  public searchTerm: string;

  private listSubscription: Subscription;

  constructor(
    private memberService: MemberService,
    private extensionService: ExtensionService,
    private assessmentService: AssessmentService,
    private formBuilder: UntypedFormBuilder,
    private messageHandlerService: MessageHandlerService,
    private authService: AuthenticationService,
    private contactHistoryService: ContactHistoryService,
    private assessmentListService: AssessmentListService,
    private translate: TranslateService,
    private documentService: DocumentService,
    private settingService: SettingService,
    private dictionaryService: DictionaryService,
    private authenticationService: AuthenticationService,
    private messengerService: MessengerService,
    public intl: IntlService)
  {
    this.dictionaryService.getCachedFlags().subscribe({
      next: (data) =>
      {
        data.forEach(d =>
        {
          if (d.displayName.includes('(') && d.displayName.includes(')'))
          {
            return;
          }
          d.displayName = `${d.displayName} (${d.code})`;
        });
        this.flags = sortBy(data, ['displayName']);
        this.allFlags = this.flags;
        this.filterFlags('');
      }
    });
  }

  public get assessmentDate(): UntypedFormControl
  {
    return this.assessmentForm.get('assessmentDate');
  }

  public get contactMethod(): UntypedFormControl
  {
    return this.assessmentForm.get('contactMethod');
  }

  public get contactEntity(): UntypedFormControl
  {
    return this.assessmentForm.get('contactEntity');
  }

  public get patientMood(): UntypedFormControl
  {
    return this.assessmentForm.get('patientMood');
  }

  public get comments(): UntypedFormControl
  {
    return this.assessmentForm.get('comments');
  }

  public get assessment(): UntypedFormControl
  {
    return this.assessmentForm.get('assessment');
  }

  public get addMood(): UntypedFormControl
  {
    return this.assessmentForm.get('addMood');
  }

  public get addFlag(): UntypedFormControl
  {
    return this.assessmentForm.get('addFlag');
  }

  public get addFollowUpTask(): UntypedFormControl
  {
    return this.assessmentForm.get('addFollowUpTask');
  }

  public get category(): UntypedFormControl
  {
    return this.assessmentForm.get('category');
  }

  public get priority(): UntypedFormControl
  {
    return this.assessmentForm.get('priority');
  }

  public get description(): UntypedFormControl
  {
    return this.assessmentForm.get('description');
  }

  public get assessmentComments(): UntypedFormControl
  {
    return this.assessmentForm.get('assessmentComments');
  }

  public get privacy(): UntypedFormControl
  {
    return this.assessmentForm.get('privacy');
  }

  public get documentName(): UntypedFormControl
  {
    return this.assessmentForm.get('documentName');
  }

  public get mimeType(): UntypedFormControl
  {
    return this.assessmentForm.get('mimeType');
  }

  @Input() public set dialogOpened(value: boolean)
  {
    if (value)
    {
      this.buildForm();
    }
  }

  public ngOnInit(): void
  {
    const currentUser = this.authService.currentUser;
    this.assessor = currentUser.name;
    this.patientMoods = this.contactHistoryService.patientMoods;
    this.patViewExtensions = new GridViewManager(99999);

    this.dictionaryService.getCachedContactTypes().subscribe({
      next: (data) =>
      {
        this.contactMethods = sortBy(data, ['id']);
      }
    });

    this.dictionaryService.getCachedContactEntities().subscribe({
      next: (data) =>
      {
        this.contactEntities = sortBy(data, ['id']);
      }
    });

    this.dictionaryService.getCachedFlagPriorities().subscribe({
      next: (data) =>
      {
        this.flagPriorities = sortBy(data, ['id']);
      }
    });

    this.dictionaryService.getCachedFlagCategories().subscribe({
      next: (data) =>
      {
        this.flagCategories = sortBy(data, ['displayName']);
      }
    });

    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.recordContactFieldsSetting = sessionSetting.recordContactFields;
        this.showMood = this.recordContactFieldsSetting.includes(this.translate.instant('SENTIMENT').toUpperCase()) ? true : false;
        this.requiredMood = this.memberService.getFieldRequiredValue(this.recordContactFieldsSetting, this.translate.instant('SENTIMENT').toUpperCase());
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
      }
    });
  }

  public ngAfterViewChecked(): void
  {
    // update splitter bar once we are sure the page is loaded
    this.updateSplitterBar();
  }

  public ngOnDestroy(): void
  {
    if (this.listSubscription !== undefined) { this.listSubscription.unsubscribe(); }
  }

  /**
   * Cancel the new assessment fulfillment.
   */
  public cancelAdd(confirm: boolean): void
  {
    if (confirm)
    {
      // Close dialog
      document.body.style.overflow = '';
      this.dialogAddAssessmentOpened = false;
      this.cancelling.emit();
    }
    this.dialogVisible = false;
  }

  public openDialog(): void
  {
    if (this.assessmentForm.dirty)
    {
      this.dialogVisible = true;
    }
    else
    {
      this.cancelAdd(true);
    }
  }

  /**
   * Save the new ad-hoc task.
   */
  public createAssessment(): void
  {
    // Make sure form template is valid
    if ((this.isFormTemplate() && (this.formFulfillment.invalid || !this.formFulfillment.dirty)) ||
      (this.isFileTemplate() && !this.selectedFile))
    {
      this.messageHandlerService.displayError('ASSESSMENT-FULFILLMENT-FORM-INVALID');
      this.tabstrip.selectTab(1);
      return;
    }

    this.creating = true;

    const objectToPersist = this.assessmentForm.value;

    objectToPersist.assessmentId = this.assessment.value.id;  // Only send assessmentId to server
    objectToPersist.memberId = this.memberId;
    objectToPersist.caseId = this.caseId;

    // Send assessment fulfillment
    objectToPersist.assessmentFulfillment = {};
    objectToPersist.assessmentFulfillment.documentId = null;   // Currently not supporting edit

    if (this.isFormTemplate())
    {
      const meta: FulfillmentMeta = new FulfillmentMeta();
      meta.data = this.model;                     // Add data model to json object
      meta.fields = this.loadedFields;            // Must keep a clean version of fields definitions for updates

      objectToPersist.assessmentFulfillment.name = this.assessment.value.name.replace(/-/g, '_').replace(/ /g, '_') + '.json';
      objectToPersist.assessmentFulfillment.mimeType = 'application/json';
      objectToPersist.assessmentFulfillment.file = Base64Util.encodeUnicode(JSON.stringify(meta));
    }
    else
    {
      const base64 = this.selectedFile.split('base64,')[1];
      objectToPersist.assessmentFulfillment.name = this.documentName.value;
      objectToPersist.assessmentFulfillment.mimeType = this.mimeType.value;
      objectToPersist.assessmentFulfillment.file = base64;
    }

    // Patient Mood
    if (objectToPersist.addMood)
    {
      objectToPersist.mood = {};
      objectToPersist.mood.comments = this.comments.value;
      objectToPersist.mood.patientMood = this.patientMood.value;
    }
    else
    {
      delete objectToPersist.mood;
    }

    // Flag
    if (objectToPersist.addFlag)
    {
      objectToPersist.flag = {};
      objectToPersist.flag.privacy = this.privacy.value === true ? 'privated' : 'shared';
      objectToPersist.flag.category = this.category.value;
      objectToPersist.flag.priority = this.priority.value;
      objectToPersist.flag.description = this.description.value;

      // Set Flag Type reference if selected from list
      const flagType = this.allFlags.find(x => x.displayName === objectToPersist.flag.description);
      objectToPersist.flag.flagType = (flagType !== undefined) ? flagType : null;
    }
    else
    {
      delete objectToPersist.flag;
    }

    // Removed unwanted fields before save
    delete objectToPersist.assessment;
    delete objectToPersist.addFlag;
    delete objectToPersist.addMood;
    delete objectToPersist.addFollowUpTask;
    delete objectToPersist.patientMood;
    delete objectToPersist.comments;
    delete objectToPersist.privacy;
    delete objectToPersist.category;
    delete objectToPersist.priority;
    delete objectToPersist.description;
    delete objectToPersist.documentName;
    delete objectToPersist.mimeType;

    objectToPersist.assessmentDate = moment.utc(this.assessmentDate.value).toDate();

    document.body.style.overflow = '';

    // This send an event to disable the task close button
    this.messengerService.sendMessage(new MessageSubject('disableTaskClose', { buttonState: true }));

    this.assessmentService.saveAssessmentFulfillment(objectToPersist).subscribe({
      next: (newAssessement) =>
      {
        this.messageHandlerService.displaySuccess('ASSESSMENT-SAVED-SUCCESSFULLY');
        newAssessement.addFollowUpTask = this.addFollowUpTask.value;
        this.save.emit(newAssessement);
        this.dialogAddAssessmentOpened = false;
      },
      error: () =>
      {
        this.messageHandlerService.displayError('ASSESSMENT-SAVE-ERROR');
      },
      complete: () =>
      {
        this.creating = false;
      }
    });
  }

  public selectPatientMood(mood: string): void
  {
    this.patientMood.setValue(mood);
  }

  public hasTask(): boolean
  {
    if (this.taskId)
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  /**
   * Check if user from dropdown is disabled or enabled.
   *
   * @returns boolean
   */
  public itemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.active;
  }

  /**
   * Filter handler for case manager assign dropdown.
   *
   * @param value User input.
   */
  public assessmentFilter(value: string): void
  {
    this.searchTerm = value;
    this.assessmentsFiltered = sortBy(this.getAssessmentsList().filter(p => p.name.toLowerCase().includes(value.toLowerCase())), ['name']);
  }

  public moodTabVisible(): boolean
  {
    return this.showMoodTab;
  }

  public flagTabVisible(): boolean
  {
    return this.showFlag;
  }

  public assessmentTabVisible(): boolean
  {
    return this.assessment !== undefined && this.assessment.value !== undefined && this.assessment.value !== null;
  }

  public isFormTemplate(): boolean
  {
    return this.assessmentTabVisible() && this.assessment.value.source === 'FORM';
  }

  public isFileTemplate(): boolean
  {
    return this.assessmentTabVisible() && this.assessment.value.source === 'STATIC';
  }

  public isShowMemberExtension(): boolean
  {
    return this.assessmentTabVisible() && this.assessment.value.showMemberExtension && this.patViewExtensions.data.length > 0;
  }

  /**
   * File has been selected.
   *
   * @param event Event
   */
  public onFileChanged(event: Event): void
  {
    const input = event.target as HTMLInputElement;
    const fileList: FileList = input.files;
    if (fileList.length > 0)
    {
      const file: File = fileList[0];

      // Validate file size
      if ((file.size / 1024) > this.fileRestrictions.maxFileSize)
      {
        this.messageHandlerService.displayError('FILE-SIZE-EXCEED-LIMIT');
        return;
      }

      // Validate file extension
      let validExtension = false;
      this.fileRestrictions.allowedExtensions.forEach((ext: string) =>
      {
        if (file.name.toLowerCase().indexOf(ext) !== -1)
        {
          validExtension = true;
        }
      });
      if (!validExtension)
      {
        this.messageHandlerService.displayDirectMessage('error',
          this.invalidFileExtensionText.replace('{{value}}', this.fileRestrictions.allowedExtensions.join()));
        return;
      }
      this.documentName.setValue(file.name);
      this.mimeType.setValue(file.type);
      this.assessmentForm.markAsDirty();
      this.setFileFromBlob(file);
    }
  }

  /**
   * Save assessment template to local
   *
   * @param url Document url
   * @param name Document file name
   */
  public downloadTemplate(assessment: any): void
  {
    this.documentService.retrieveDocument(assessment.documentUrl).subscribe({
      next: (data) =>
      {
        saveAs(`data:${data.mimeType};base64,${data.content}`, assessment.documentName);
      }
    });
  }

  /**
   * Filters the flags based on user input.
   */
  public filterFlags(filter: string): void
  {
    this.searchTerm = filter;
    this.flagsFiltered = this.flags
      .filter(flag => flag.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  public onSelectTab(event: SelectEvent)
  {
    this.selectedTab = event.index;
    if (this.selectedTab === 1)
    {
      // Work around to set the focus on the first control to let the select to load it's value
      setTimeout(() =>
      {
        // Set formly valueChanges event for sum (if any)
        this.assessmentService.setFormlyControlsSum(this.fields, this.formFulfillment);

        if (this.survey?.nativeElement &&
          this.survey?.nativeElement?.childNodes && this.survey?.nativeElement?.childNodes.length > 0 &&
          this.survey.nativeElement.childNodes[0].elements && this.survey.nativeElement.childNodes[0].elements.length > 0)
        {
          this.survey.nativeElement.childNodes[0].elements[0].focus();
        }
      }, 500);
    }
  }

  /**
   * Filters all flags based on user input.
   */
  public filterAllFlags(filter: string): void
  {
    this.searchTerm = filter;
    if (this.assessmentForm.get('category').value != null)
    {
      if (this.assessmentForm.get('category').value.codeSetPerRecord != null)
      {
        this.dictionaryService.getCodesByCodeSetId(this.assessmentForm.get('category').value.codeSetPerRecord.id).subscribe({
          next: (data) =>
          {
            this.allFlags = sortBy(data, ['displayName']);
            this.allFlagsFiltered = this.allFlags
              .filter(flag => flag.displayName.toLowerCase().includes(filter.toLowerCase()));
          }
        });
      }
      else
      {
        this.allFlags = this.flags;
        this.allFlagsFiltered = this.allFlags
          .filter(flag => flag.displayName.toLowerCase().includes(filter.toLowerCase()));
      }
    }
  }

  /**
   * Data change event handler.
   *
   * @param state State of grid operations
   */
  public patExtensionsDataStateChange(state: DataStateChangeEvent): void
  {
    this.patViewExtensions.setState(state);
  }

  public formatExtensionValue(dataItem: any): string
  {
    return this.extensionService.formatExtensionValue(dataItem);
  }

  /**
    * This method is to set the person extensions height
    *
    * @param e ResizedEvent
    */
  public onResized(e: ResizedEvent): void
  {
    setTimeout(() =>
    {
      if (this.formlyDiv)
      {
        const tabHeight = 45;
        this.maxWindowHeight = e.newHeight - 170 - tabHeight;
        this.currentMaxExtensionHeight = this.maxWindowHeight + 10;
      }
    }, 250);
  }

  public onStateChange(state: string): void
  {
    this.windowState = state;
  }

  public updateSplitterBar()
  {
    // do not run if no splitter is loaded
    if (!this.splitter) { return; }

    const bar = this.splitter.nativeElement.querySelector('.k-splitbar');

    if (bar)
    {
      const pane = this.splitter.nativeElement.querySelector('.k-pane');
      const size = pane ? pane.offsetWidth : 0;

      bar.setAttribute('aria-valuenow', size.toString());
      bar.setAttribute('aria-valuemax', '9999');
    }
  }

  private clearFlags(): void
  {
    this.assessmentForm.get('description').value = null;
    if (this.singleSelect !== undefined)
    {
      this.singleSelect.reset();
    }
  }

  private getFlags(event: any, initializationContext: boolean)
  {
    if (event && event !== undefined && event.id !== undefined)
    {
      if (event.codeSetPerRecord != null)
      {
        this.currentDictionaryUsed = 1;
        this.dictionaryService.getCodesByCodeSetId(event.codeSetPerRecord.id).subscribe({
          next: (data) =>
          {
            this.allFlagsFiltered = sortBy(data, ['displayName']);
          }
        });
      }
      else
      {
        this.currentDictionaryUsed = 2;
        this.allFlagsFiltered = this.flagsFiltered;
      }
      // Reset only if the dictionary has changed
      if (!initializationContext)
      {
        if ((this.currentDictionaryUsed !== this.previousDictionaryUsed) || (this.currentDictionaryUsed === 1))
        {
          this.clearFlags();
        }
      }
      this.previousDictionaryUsed = this.currentDictionaryUsed;
    }
  }

  private setControlState(category: string): void
  {
    if (category !== null && category !== undefined && category !== '')
    {
      this.description.enable();
    }
    else
    {
      this.description.disable();
      this.clearFlags();
    }
  }

  private buildForm(): void
  {
    this.selectedFile = null;

    const state = {
      filter: {
        filters: [], logic: 'and'
      },
      group: [],
      skip: 0,
      sort: [{ field: 'name', dir: 'asc' }],
      take: 99999
    };

    if (this.assessmentId > 0)
    {
      state.filter.filters.push({ field: 'id', operator: 'eq', value: this.assessmentId });
    }
    else
    {
      state.filter.filters.push({ field: 'deleted', operator: 'eq', value: false });
      state.filter.filters.push({ field: 'workflowOnly', operator: 'eq', value: false });
    }

    state.filter.filters.push({ field: 'consentType', operator: 'eq', value: false });

    // Get the translation used when file types is invalid
    this.translate.get('INVALID-FILE-TYPE').subscribe({
      next: (value) =>
      {
        this.invalidFileExtensionText = value;
      }
    });

    if (this.listSubscription === undefined)
    {
      this.listSubscription = this.assessmentListService.subscribe({
        next: (value) =>
        {
          if (value !== null)
          {
            const assessments = cloneDeep(value.data);
            assessments.forEach(d => { d.name = d.name + (d.assessmentVersion ? ' - v' + d.assessmentVersion : ''); });
            this.assessments = assessments.filter(x => x.active);
            this.assessmentFilter('');
          }
        }
      });
    }

    this.assessmentListService.queryByState(state, () =>
    {
      this.showMoodTab = false;
      this.showFlag = false;

      let disabledAssessment = false;
      let selectedAssessment = null;

      // assessmentId will be > 0 in the task context.
      if (this.assessmentId > 0)
      {
        const assessmentsFiltered = this.assessments.filter(x => x.id.toString() === this.assessmentId.toString());
        // Automatically select the assessment based that is defined on the assessment task from the modeler.
        if (assessmentsFiltered.length === 1)
        {
          this.assessmentsFiltered = assessmentsFiltered;
          disabledAssessment = true;
          selectedAssessment = this.assessmentsFiltered[0];
          this.initAssessmentForm(this.assessmentId);
        }
        else
        {
          // If the assessment can't be find from the modeler, we leave the assessment drop-down open.
          // Otherwise we can't complete the task. This should not happen since we get the assessment by id.
        }
      }
      else
      {
        this.assessmentsFiltered = this.getAssessmentsList();
      }

      const moodValidator = this.showMood && this.showMoodTab ? this.requiredMood : [];

      this.assessmentForm = this.formBuilder.group({
        id: null,
        assessmentDate: [this.maxDate, Validators.required],
        assessment: [{ value: selectedAssessment, disabled: disabledAssessment }, Validators.required],
        contactMethod: [null, Validators.required],
        contactEntity: [null, Validators.required],
        addFollowUpTask: false,
        documentName: [{ value: null, disabled: true }],
        mimeType: null,
        assessmentComments: null,
        // Mood fields
        addMood: false,
        patientMood: [null, moodValidator === true ? [Validators.required] : []],
        comments: null,
        // Flag fields
        addFlag: false,
        description: null,
        priority: null,
        category: null,
        privacy: true
      });

      this.assessmentForm.get('assessment').valueChanges.subscribe({
        next: (assessment: any) =>
        {
          // If there is an assessment selected.
          if (assessment !== undefined)
          {
            this.initAssessmentForm(assessment.id);
          }
        }
      });

      if (this.showMood)
      {
        this.assessmentForm.get('addMood').valueChanges.subscribe({
          next: (value: any) =>
          {
            this.showMoodTab = value;
            const validator = [];
            const moodValidator = this.showMood && this.showMoodTab ? this.requiredMood : [];
            if (this.showMoodTab)
            {
              if (moodValidator === true)
              {
                validator.push(Validators.required);
              }
              else
              {
                validator.push([]);
              }
            }
            this.assessmentForm.get('patientMood').setValidators(validator);
            this.assessmentForm.get('patientMood').updateValueAndValidity();
          }
        });
      }

      this.assessmentForm.get('addFlag').valueChanges.subscribe({
        next: (value: any) =>
        {
          this.showFlag = value;
          const flagValidator = [];
          if (this.showFlag)
          {
            flagValidator.push(Validators.required);
          }
          this.assessmentForm.get('category').setValidators(flagValidator);
          this.assessmentForm.get('priority').setValidators(flagValidator);
          this.assessmentForm.get('description').setValidators(flagValidator);
          this.assessmentForm.get('category').updateValueAndValidity();
          this.assessmentForm.get('priority').updateValueAndValidity();
          this.assessmentForm.get('description').updateValueAndValidity();

          this.assessmentForm.get('category').valueChanges.subscribe({
            next: (category: string) =>
            {
              this.setControlState(category);
            }
          });
          this.setControlState(this.category.value);
          this.getFlags(this.category.value, true);
        }
      });

      this.windowState = 'maximized';
      document.body.style.overflow = 'hidden';
      this.dialogAddAssessmentOpened = true;
    });
  }

  /**
   * Set the selected file.
   *
   * @param file Selected file.
   */
  private setFileFromBlob(file: Blob): void
  {
    const reader = new FileReader();
    reader.addEventListener('load', () =>
    {
      this.selectedFile = reader.result;
    }, false);
    reader.readAsDataURL(file);
  }

  private initAssessmentForm(assessmentId: number): void
  {
    this.assessmentService.getAssessment(assessmentId).subscribe({
      next: (d) =>
      {
        const documentNameValidator = [];

        // If form fields, set fields, model and form.
        if (d.source === 'FORM')
        {
          this.fields = JSON.parse(Base64Util.decodeUnicode(d.fields));
          this.loadedFields = cloneDeep(this.fields);
          this.model = {};

          // The following method process all date and datetime and assign today's default
          this.assessmentService.setFormlyModelDefaults(this.fields, this.model);

          this.formFulfillment = new UntypedFormGroup({});
          this.loadPatientExtensions();
        }
        else
        {
          documentNameValidator.push(Validators.required);
        }
        this.assessmentForm.get('documentName').setValidators(documentNameValidator);
        this.assessmentForm.get('documentName').updateValueAndValidity();
      }
    });
  }

  private getAssessmentsList(): any[]
  {
    if (this.caseId === null || this.authenticationService.currentUser.role !== 'ROLE_OPERATOR')
    {
      // Must hide all assessments with sentivitities
      return this.assessments.filter(x => x.sensitivities.length === 0);
    }
    else
    {
      return this.assessments;
    }
  }

  private loadPatientExtensions(): void
  {
    if (this.assessment && this.assessment.value && this.assessment.value.showMemberExtension && this.memberId)
    {
      this.memberService.getMember(this.memberId).subscribe({
        next: (data: any) =>
        {
          this.patViewExtensions.setData(data.extensions ? data.extensions : []);
          this.setViewExtensionsColumnsVisibility();
        },
        error: (errorResponse: any) =>
        {
          this.messageHandlerService.displayError(errorResponse);
        }
      });
    }
  }

  private setViewExtensionsColumnsVisibility(): void 
  {
    this.viewExtensionsShowDisplayName = this.patViewExtensions.data.filter(x => x.displayName).length > 0;
    this.viewExtensionsShowAlternateValue = this.patViewExtensions.data.filter(x => x.alternateValue).length > 0;
  }
}
